'use strict';

var App = require('app');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');

var Label = Backbone.Model.extend({
    defaults: {
        modelType: 'label',
    },

    url: function () {
        return '/api/v1/devices/' + this.id + '/labels';
    },
});

var API = {
    getLabels: function (id) {
        var label = new Label({ id: id });
        var defer = $.Deferred();

        label.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    saveLabels: function (labels, ids) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'POST',
                url: '/api/v1/labels',
                data: JSON.stringify({
                    tags: labels.tags,
                    groups: labels.groups,
                    list: ids,
                }),
                success: function () {
                    defer.resolve(undefined);
                },
                error: function (response, err) {
                    defer.resolve(
                        response.responseJSON || {
                            error: I18N.TR('Fehler beim Aktualisieren des Wertes.'),
                            sysErr: response.responseText || '',
                        }
                    );
                },
            });
        });
    },

    labelPoolList: function () {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: '/api/v1/label-pool',
                success: function (data) {
                    defer.resolve(data);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    labelPoolSave: function (pool) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'POST',
                url: '/api/v1/label-pool',
                data: JSON.stringify(pool),
                success: function () {
                    defer.resolve();
                },
                error: function (r) {
                    defer.resolve(r.responseJSON || { error: 'request failed' });
                },
            });
        });
    },

    labelPoolDelete: function () {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'DELETE',
                url: '/api/v1/label-pool',
                success: function () {
                    defer.resolve(undefined);
                },
                error: function (r) {
                    defer.resolve({ error: 'request failed' });
                },
            });
        });
    },
};

App.reqres.setHandler('label:model', function (id) {
    return API.getLabels(id);
});

App.reqres.setHandler('label:save', function (labels, ids) {
    return API.saveLabels(labels, ids);
});

App.reqres.setHandler('label:pool:list', function () {
    return API.labelPoolList();
});

App.reqres.setHandler('label:pool:save', function (pool) {
    return API.labelPoolSave(pool);
});

App.reqres.setHandler('label:pool:delete', function () {
    return API.labelPoolDelete();
});

module.exports = Label;
